module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.documents) ? _c('f7-list', {
    staticClass: "itemList",
    attrs: {
      "accordion-list": "",
      "id": "payments-item-received"
    }
  }, _vm._l((_vm.documents), function(document) {
    return _c('ul', {
      key: document.IdDocument
    }, [_c('li', {
      staticClass: "swipeout",
      on: {
        "click": function($event) {
          return _vm.seeDetails(document)
        }
      }
    }, [_c('div', {
      staticClass: "item-content boxRequest"
    }, [_c('div', {
      staticClass: "item-media"
    }, [_c('div', {
      style: ({
        background: _vm.rectangleColor
      }),
      attrs: {
        "id": "greenRectangle"
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "icon list-icon",
      class: _vm.getIcon(document.Status)
    })]), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('table', {
      staticStyle: {
        "table-layout": "fixed"
      },
      attrs: {
        "width": "100%"
      }
    }, [_c('tr', [_c('td', {
      class: _vm.getLabelColorClass(document.Status),
      attrs: {
        "width": "20%"
      }
    }, [_c('span', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                  " + _vm._s(_vm.getStatusLabel(document.Status, document.Role)) + "\n                ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                  " + _vm._s(_vm.getDocumentType(document)) + "\n                ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                  " + _vm._s(document.GroupReference) + "\n                ")])]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "showLargeScreenOnly"
    }, [_vm._v("\n                  " + _vm._s(_vm.getDate(document)) + "\n                ")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "detailsDocumentStatus showSmallScreenOnly"
    }, [_vm._v("\n                " + _vm._s(_vm.getStatusLabel(document.Status, document.Role)) + "\n              ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "showSmallScreenOnly",
      attrs: {
        "colspan": "4"
      }
    }, [_vm._v("\n                " + _vm._s(_vm.getDate(document)) + "\n              ")])])])])])])])
  }), 0) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42033f6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42033f6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/DocumentToValidateList.vue
// module id = 2400
// module chunks = 2